<script setup lang="ts">
import { AppFlicker, AppSvgIcon } from '@libs/ui';

import type { PeekPriceUnbookableTransportCardData } from '../models';

interface PeekPriceUnbookableTransportCardProps {
  data: PeekPriceUnbookableTransportCardData;
}

const props = defineProps<PeekPriceUnbookableTransportCardProps>();
</script>

<template>
  <div class="peek-price-unbookable-transport-card">
    <div class="unbookable-transport-icon">
      <AppSvgIcon :name="props.data.icon" size="24" />
    </div>

    <div class="unbookable-transport-content">
      <div v-if="props.data.date" class="unbookable-transport-date">
        {{ props.data.date }}
      </div>
      <div v-else class="unbookable-transport-date-flicker">
        <AppFlicker height="100%" width="spacing-40" />
      </div>
      <div class="unbookable-transport-type">
        {{ props.data.description }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.peek-price-unbookable-transport-card {
  display: flex;
  gap: var(--spacing-12);
  align-items: center;

  .unbookable-transport-icon {
    --size: 60px;
    width: var(--size);
    height: var(--size);

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .unbookable-transport-content {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);

    .unbookable-transport-date {
      @include font-label-s-light;
      color: var(--color-neutral-70);
    }

    .unbookable-transport-date-flicker {
      height: 15px;
    }

    .unbookable-transport-type {
      @include font-label-m-bold;
      color: var(--color-neutral-70);
    }
  }
}
</style>
